// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".limit-class[data-v-1f1044d3] .el-upload--picture-card {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
